import api from './api';

// Signature service methods
const signatureService = {
  // Get the current user's signature
  getUserSignature: async () => {
    try {
      const response = await api.get('/signatures');
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },

  // Save a signature
  saveSignature: async (imageData) => {
    try {
      const response = await api.post('/signatures', { imageData });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },

  // Delete a signature
  deleteSignature: async () => {
    try {
      const response = await api.delete('/signatures');
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },

  // Sign a receipt
  signReceipt: async (receiptId, signatures) => {
    try {
      const response = await api.post(`/receipts/${receiptId}/sign`, signatures);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },

  // Sign a contract
  signContract: async (contractId, signatures) => {
    try {
      const response = await api.post(`/contracts/${contractId}/sign`, signatures);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  }
};

export default signatureService;